import * as React from 'react';
import snarkdown from '@bpmn-io/snarkdown';
import escape from 'lodash/escape';
import ReactDOM from 'react-dom/server';
import { escapeMarkdown } from '../react/utils/escapeMarkdown';
const componentToString = (key, elt) => {
  if (! /*#__PURE__*/React.isValidElement(elt) && !Array.isArray(elt)) return elt;
  try {
    return ReactDOM.renderToStaticMarkup(elt);
  } catch (err) {
    console.warn(`In @gandi/translate, unable to render component ${key}`, err);
    return elt;
  }
};
const enhanceTranslate = (namespace, translate, sanitize, logger) => (message, options = {}) => {
  const defaultOptions = {
    withHTML: false,
    withMarkdown: false,
    escapeParameters: false,
    scope: namespace,
    fallback: message
  };
  let parsedOptions = {
    ...defaultOptions,
    ...options
  };
  if ('count' in parsedOptions) {
    parsedOptions.count = parseInt(parsedOptions.count, 10) || 0;
  }
  if (parsedOptions.withMarkdown) {
    parsedOptions.withHTML = true;
  }
  parsedOptions = Object.keys(parsedOptions).reduce((acc, key) => {
    acc[key] = componentToString(key, parsedOptions[key]);
    return acc;
  }, {});
  if (parsedOptions.withHTML && !('escapeParameters' in options)) {
    parsedOptions.escapeParameters = true;
  }
  if (parsedOptions.escapeParameters === true) {
    parsedOptions = Object.keys(parsedOptions).reduce((acc, key) => {
      let value = parsedOptions[key];
      if (typeof value === 'string' && ['scope', 'fallback'].indexOf(key) === -1) {
        if (parsedOptions.withMarkdown) {
          value = escapeMarkdown(value);
        }
        value = escape(value);
      }
      acc[key] = value;
      return acc;
    }, {});
  }
  if (parsedOptions.withHTML) {
    let html;
    let translatedMessage = '';
    try {
      translatedMessage = translate(message, parsedOptions);
    } catch (err) {
      logger.error({
        err
      }, `Error during the translation of the message "${message}". ` + 'Check that all arguments are defined.');
    }
    if (parsedOptions.withMarkdown) {
      html = snarkdown(translatedMessage).replace(/\n/g, '');
    } else {
      html = translatedMessage;
    }
    return {
      __html: html
    };
  }
  try {
    const translatedMessage = translate(message, parsedOptions);
    return typeof sanitize === 'function' ? sanitize(translatedMessage) : translatedMessage;
  } catch (err) {
    logger.error({
      err
    }, `Error during the translation of the message "${message}". ` + 'Check that all arguments are defined.');
    return '';
  }
};
export default enhanceTranslate;